import React from 'react';
import { Link } from 'react-router-dom';
import { Brain, ArrowLeft } from 'lucide-react';

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="text-lg font-semibold text-white mb-3">{title}</h2>
    <div className="text-gray-400 text-sm leading-relaxed space-y-2">{children}</div>
  </div>
);

const TermsOfService = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
    <div className="max-w-2xl mx-auto px-6 py-12">

      <div className="flex items-center gap-3 mb-10">
        <div className="w-9 h-9 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center">
          <Brain size={18} className="text-white" />
        </div>
        <span className="text-lg font-semibold">MLense Platform</span>
      </div>

      <h1 className="text-3xl font-bold mb-2">Terms of Service</h1>
      <p className="text-gray-500 text-sm mb-10">Last updated: June 2026</p>

      <Section title="1. Acceptance">
        <p>By creating an account you agree to these terms. If you do not agree, do not use the platform.</p>
      </Section>

      <Section title="2. What the Platform Does">
        <p>MLense lets you upload datasets, build machine-learning pipelines, train models, and inspect results — all through a visual interface. No ML expertise is required.</p>
      </Section>

      <Section title="3. Your Data &amp; Datasets">
        <p>You retain ownership of any data you upload. By uploading, you grant MLense a limited license to process that data solely to provide the service to you.</p>
        <p>Do not upload data you do not own or that contains personal information of others without their consent.</p>
      </Section>

      <Section title="4. Account Responsibilities">
        <p>You are responsible for keeping your credentials confidential. You must be at least 16 years old to use this platform. One account per person.</p>
      </Section>

      <Section title="5. Prohibited Use">
        <p>You may not use this platform to train models intended to harm, deceive, or discriminate against individuals, or to process data in violation of applicable law.</p>
      </Section>

      <Section title="6. Service Availability">
        <p>The platform is provided as-is. We do not guarantee uninterrupted availability and may update, suspend, or discontinue features with reasonable notice.</p>
      </Section>

      <Section title="7. Limitation of Liability">
        <p>MLense is not liable for model outputs, business decisions made from predictions, or data loss. Use model results as a tool, not a final authority.</p>
      </Section>

      <Section title="8. Changes">
        <p>We may update these terms. Continued use after changes are posted means you accept the revised terms.</p>
      </Section>

      <Link
        to="/register"
        className="inline-flex items-center gap-2 text-sm text-blue-400 hover:text-blue-300 transition-colors mt-4"
      >
        <ArrowLeft size={15} />
        Back to registration
      </Link>

      <p className="text-gray-600 text-xs mt-10">© 2026 MLense Platform. All rights reserved.</p>
    </div>
  </div>
);

export default TermsOfService;
